"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require.setupForSimpleEventAccessors;

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var Event = require("../generated/Event");

var AbortSignalImpl = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(AbortSignalImpl, _EventTargetImpl);

  var _super = _createSuper(AbortSignalImpl);

  function AbortSignalImpl(args, privateData) {
    var _this;

    _classCallCheck(this, AbortSignalImpl);

    _this = _super.call(this); // make event firing possible

    _this._ownerDocument = privateData.window.document;
    _this.aborted = false;
    _this.abortAlgorithms = new Set();
    return _this;
  }

  _createClass(AbortSignalImpl, [{
    key: "_signalAbort",
    value: function _signalAbort() {
      if (this.aborted) {
        return;
      }

      this.aborted = true;

      var _iterator = _createForOfIteratorHelper(this.abortAlgorithms),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var algorithm = _step.value;
          algorithm();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.abortAlgorithms.clear();

      this._dispatch(Event.createImpl(["abort", {
        bubbles: false,
        cancelable: false
      }], {
        isTrusted: true
      }));
    }
  }, {
    key: "_addAlgorithm",
    value: function _addAlgorithm(algorithm) {
      if (this.aborted) {
        return;
      }

      this.abortAlgorithms.add(algorithm);
    }
  }, {
    key: "_removeAlgorithm",
    value: function _removeAlgorithm(algorithm) {
      this.abortAlgorithms.delete(algorithm);
    }
  }]);

  return AbortSignalImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(AbortSignalImpl.prototype, ["abort"]);
module.exports = {
  implementation: AbortSignalImpl
};